import { forwardRef, type Ref, type SVGProps } from "react";
const IconVolumeLowFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M15.693 6.908a.97.97 0 0 1 1.065-.144c.351.17.575.537.576.94v16.593c0 .402-.225.768-.576.939a.97.97 0 0 1-1.065-.144l-5.721-4.944H6.334c-.553 0-1-.465-1-1.037v-6.222c0-.572.447-1.037 1-1.037h3.638z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconVolumeLowFilledSVG);
ForwardRef.displayName = "IconVolumeLowFilled";
export { ForwardRef as IconVolumeLowFilled };
